import script from "./sendLinkModel.vue?vue&type=script&lang=ts&setup=true"
export * from "./sendLinkModel.vue?vue&type=script&lang=ts&setup=true"

import "./sendLinkModel.vue?vue&type=style&index=0&id=15f46a92&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15f46a92"]])

export default __exports__